import { HeaderMenu } from '../components/menu/header-menu';
import { SmoothScroll } from './js/base/smooth-scroll';

new HeaderMenu();
new SmoothScroll();